import { Dispatch, useEffect, RefObject, SetStateAction } from 'react';

import { useSocket } from 'context';

interface UseProcessingClover {
  isProcessingInCloverRef: RefObject<boolean>;
  setCancelDisabled: Dispatch<SetStateAction<boolean>>;
}

export const useProcessingClover = ({
  setCancelDisabled,
  isProcessingInCloverRef,
}: UseProcessingClover) => {
  const { socket, subscribe } = useSocket();

  useEffect(() => {
    const unsubscribe = subscribe('processing-clover', (event) => {
      console.log('[Payment]: socket processing clover', event);
      if (event.isProcessingInClover) {
        isProcessingInCloverRef.current = true;
        setCancelDisabled(true);
      }
    });

    return unsubscribe;
  }, [socket, subscribe, setCancelDisabled]);
};
